
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/location",
      function () {
        return require("private-next-pages/shop/location/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/location"])
      });
    }
  